<h2 class="heading-4">{{ vm.claimType === 'service' ? 'Your annual service' : 'Your repair' }}</h2>

<p class="body mt-8">Sorry, our online booking is temporarily down.</p>
<p class="body">If you want to book a repair or for any help, please give us a call.</p>

<app-telephone-link class="mt-8" phoneNumber="0333 000 9703" [postCode]="vm.postCode" />
